import React from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import { AngularContext } from 'react-app';

import GradientAiIcon from 'lecture_pages/components/left-panel/novo-ai/components/shared/gradient-ai-icon';
import { AIFeedbackDataRequest } from 'redux/schemas/models/submissions';
import aiInsightsPillStyles from './styles';

const AiInsightsStatusPill: React.FC = () => {
  const { injectServices } = React.useContext(AngularContext);
  const [ReportsManager] = injectServices(['ReportsManager']);

  const submissions = useSelector((state: any) => state?.models?.submissions);
  const { currentReport } = ReportsManager;
  const storeReport = submissions?.[currentReport?.id];
  const reportAiFeedback = storeReport?.aiFeedback || currentReport?.aiFeedback;
  const feedbackDataRequest = (storeReport?.feedbackDataRequest || currentReport?.feedbackDataRequest) as AIFeedbackDataRequest;

  const isGenerating = feedbackDataRequest?.completed === false;
  const isGenerated = feedbackDataRequest?.completed === true && !!reportAiFeedback;

  if (!isGenerating && !isGenerated) {
    return null;
  }

  const handleClick = () => {
    const section = document.getElementById('ai-insights-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      css={aiInsightsPillStyles}
      onClick={handleClick}
      data-qa={isGenerating ? 'ai-insights-pill-generating' : 'ai-insights-pill-generated'}
      type='button'
    >
      <GradientAiIcon icon='gen-ai' size='xss-smallest' />
      <span>
        {isGenerating
          ? t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS.GENERATING()
          : t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS.GENERATED()}
      </span>
    </button>
  );
};

export default AiInsightsStatusPill;
